import React from 'react';
import DataThresholdingIcon from '@mui/icons-material/DataThresholding';
import { ExportStatisticsProps } from './types';
import { Button } from '@mui/material';
import strings from '../../resources/strings';
import { CSVLink } from 'react-csv';
import './ExportStatistics.scss';

const ExportStatistics: React.FC<ExportStatisticsProps> = (props) => {
    const getFileName = () => {
        const date = new Date();
        const formatedDate = date.toISOString().split('T')[0];
        return `statistics_${formatedDate}.csv`;
    };

    return (
        <div>
            <CSVLink data={props.data} headers={props.headers} filename={getFileName()} className="export-btn">
                <Button variant="outlined" startIcon={<DataThresholdingIcon />}>
                    {strings.exportStatistics.buttonTitle}
                </Button>
            </CSVLink>
        </div>
    );
};

export default ExportStatistics;
